import { ConditionType, MessageRow as SharedMessageRow, messageChannelFromName } from '@/features/dryad';
import { ConditionTypeSelect } from './condition-type-select';

type MessageRowProps = {
  /** The leaf node's id, supplied by the group to every registered view. */
  id: string;
};

/**
 * The people surface's binding of the shared message row. The channel
 * derivation is this surface's, because the event name it reads is the
 * people-search wire's picker grammar.
 */
export function MessageRow({ id }: MessageRowProps) {
  return (
    <SharedMessageRow
      id={id}
      conditionType={ConditionType.Message}
      typeSelect={<ConditionTypeSelect nodeId={id} currentType={ConditionType.Message} />}
      channelFromName={messageChannelFromName}
    />
  );
}
